"use client";

import { Cookie, X } from "lucide-react";
import { useEffect, useState } from "react";

const STORAGE_KEY = "cookie-consent-dismissed";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    if (window.localStorage.getItem(STORAGE_KEY) !== "true") {
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    window.localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 sm:right-auto sm:max-w-md">
      <div className="flex items-start gap-3 rounded-2xl bg-neutral-800 p-4 shadow-lg">
        <div className="flex shrink-0 items-center justify-center rounded-full bg-white p-2">
          <Cookie className="size-5 text-neutral-800" />
        </div>
        <p className="flex-1 text-sm leading-5 text-white">
          Size daha iyi bir deneyim sunmak ve sitemizi optimize etmek için
          çerezler kullanıyoruz. Ayrıntılı bilgi için{" "}
          <a
            className="text-brand-blue-400 underline hover:text-brand-blue-300"
            href="https://www.e-bebek.com/ebebek-cerez-politikasi"
            rel="noopener noreferrer"
            target="_blank"
          >
            Çerez Politikamızı
          </a>{" "}
          inceleyiniz.
        </p>
        <button
          aria-label="Kapat"
          className="shrink-0 text-white/70 transition-colors hover:text-white"
          onClick={handleClose}
          type="button"
        >
          <X className="size-5" />
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
